module.exports = __webpack_public_path__ + "img/camera.9449e17a.jpg";